export const statuses = {
  DELETED: "deleted",
  ADDED: "added",
};
